import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'

export interface TenantPhoneNumberResponse {
    phone_number: string | null
}

export const tenantIntegrationsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getTenantPhoneNumber: builder.query<TenantPhoneNumberResponse, void>({
            query: () => apiEndpoints.tenantIntegrations.phoneNumber,
        }),
    }),
    overrideExisting: false,
})

export const { useGetTenantPhoneNumberQuery } = tenantIntegrationsApi
